export default __webpack_public_path__ + "static/media/right.bf55e9d4.svg";